<template lang="pug">
</template>

<script>
import { getLoginModuleData } from '@/services/API/module/ModuleService'
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
    name: 'main',
    props: {},
    data: function() {
        return {}
    },
    computed: {},
    methods: {
        logout() {
            this.goToMenu().then(console.log('asdf'))
            /*
            this.logoutRequestAction()
                .then(() => {
                    if (process.env.VUE_APP_BY_PASS_LOGIN === 'false')
                        this.goToLoginModule()
                })
                .catch(err => {
                    console.log(err)
                    if (process.env.VUE_APP_BY_PASS_LOGIN === 'false')
                        this.goToLoginModule()
                })
                */
        },
        ...mapActions('AuthModule', {
            logoutRequestAction: 'logoutRequestAction',
            goToMenu: 'goToMenu',
        }),
        goToLoginModule() {
            getLoginModuleData() // Go to mod_login
                .then(response => {
                    let urlLoginModule = response.data.g_login_module.url_module
                    window.location = urlLoginModule
                })
                .catch(err => {
                    console.log('Error get Module URL')
                })
        },
    },
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function() {
        this.logout()
    },
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>
